/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.MsgReadStatusMsg = (function() {

    /**
     * Properties of a MsgReadStatusMsg.
     * @exports IMsgReadStatusMsg
     * @interface IMsgReadStatusMsg
     * @property {string|null} [guid] MsgReadStatusMsg guid
     * @property {number|null} [version] MsgReadStatusMsg version
     * @property {string|null} [fromGuid] MsgReadStatusMsg fromGuid
     * @property {string|null} [targetGuid] MsgReadStatusMsg targetGuid
     * @property {Array.<string>|null} [msgGuid] MsgReadStatusMsg msgGuid
     * @property {string|null} [startMsgGuid] MsgReadStatusMsg startMsgGuid
     * @property {string|null} [endMsgGuid] MsgReadStatusMsg endMsgGuid
     */

    /**
     * Constructs a new MsgReadStatusMsg.
     * @exports MsgReadStatusMsg
     * @classdesc Represents a MsgReadStatusMsg.
     * @implements IMsgReadStatusMsg
     * @constructor
     * @param {IMsgReadStatusMsg=} [properties] Properties to set
     */
    function MsgReadStatusMsg(properties) {
        this.msgGuid = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MsgReadStatusMsg guid.
     * @member {string} guid
     * @memberof MsgReadStatusMsg
     * @instance
     */
    MsgReadStatusMsg.prototype.guid = "";

    /**
     * MsgReadStatusMsg version.
     * @member {number} version
     * @memberof MsgReadStatusMsg
     * @instance
     */
    MsgReadStatusMsg.prototype.version = 0;

    /**
     * MsgReadStatusMsg fromGuid.
     * @member {string} fromGuid
     * @memberof MsgReadStatusMsg
     * @instance
     */
    MsgReadStatusMsg.prototype.fromGuid = "";

    /**
     * MsgReadStatusMsg targetGuid.
     * @member {string} targetGuid
     * @memberof MsgReadStatusMsg
     * @instance
     */
    MsgReadStatusMsg.prototype.targetGuid = "";

    /**
     * MsgReadStatusMsg msgGuid.
     * @member {Array.<string>} msgGuid
     * @memberof MsgReadStatusMsg
     * @instance
     */
    MsgReadStatusMsg.prototype.msgGuid = $util.emptyArray;

    /**
     * MsgReadStatusMsg startMsgGuid.
     * @member {string} startMsgGuid
     * @memberof MsgReadStatusMsg
     * @instance
     */
    MsgReadStatusMsg.prototype.startMsgGuid = "";

    /**
     * MsgReadStatusMsg endMsgGuid.
     * @member {string} endMsgGuid
     * @memberof MsgReadStatusMsg
     * @instance
     */
    MsgReadStatusMsg.prototype.endMsgGuid = "";

    /**
     * Creates a new MsgReadStatusMsg instance using the specified properties.
     * @function create
     * @memberof MsgReadStatusMsg
     * @static
     * @param {IMsgReadStatusMsg=} [properties] Properties to set
     * @returns {MsgReadStatusMsg} MsgReadStatusMsg instance
     */
    MsgReadStatusMsg.create = function create(properties) {
        return new MsgReadStatusMsg(properties);
    };

    /**
     * Encodes the specified MsgReadStatusMsg message. Does not implicitly {@link MsgReadStatusMsg.verify|verify} messages.
     * @function encode
     * @memberof MsgReadStatusMsg
     * @static
     * @param {IMsgReadStatusMsg} message MsgReadStatusMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MsgReadStatusMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromGuid);
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.targetGuid);
        if (message.msgGuid != null && message.msgGuid.length)
            for (var i = 0; i < message.msgGuid.length; ++i)
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.msgGuid[i]);
        if (message.startMsgGuid != null && message.hasOwnProperty("startMsgGuid"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.startMsgGuid);
        if (message.endMsgGuid != null && message.hasOwnProperty("endMsgGuid"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.endMsgGuid);
        return writer;
    };

    /**
     * Encodes the specified MsgReadStatusMsg message, length delimited. Does not implicitly {@link MsgReadStatusMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MsgReadStatusMsg
     * @static
     * @param {IMsgReadStatusMsg} message MsgReadStatusMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MsgReadStatusMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MsgReadStatusMsg message from the specified reader or buffer.
     * @function decode
     * @memberof MsgReadStatusMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MsgReadStatusMsg} MsgReadStatusMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MsgReadStatusMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MsgReadStatusMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.fromGuid = reader.string();
                break;
            case 4:
                message.targetGuid = reader.string();
                break;
            case 5:
                if (!(message.msgGuid && message.msgGuid.length))
                    message.msgGuid = [];
                message.msgGuid.push(reader.string());
                break;
            case 6:
                message.startMsgGuid = reader.string();
                break;
            case 7:
                message.endMsgGuid = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MsgReadStatusMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MsgReadStatusMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MsgReadStatusMsg} MsgReadStatusMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MsgReadStatusMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MsgReadStatusMsg message.
     * @function verify
     * @memberof MsgReadStatusMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MsgReadStatusMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            if (!$util.isString(message.targetGuid))
                return "targetGuid: string expected";
        if (message.msgGuid != null && message.hasOwnProperty("msgGuid")) {
            if (!Array.isArray(message.msgGuid))
                return "msgGuid: array expected";
            for (var i = 0; i < message.msgGuid.length; ++i)
                if (!$util.isString(message.msgGuid[i]))
                    return "msgGuid: string[] expected";
        }
        if (message.startMsgGuid != null && message.hasOwnProperty("startMsgGuid"))
            if (!$util.isString(message.startMsgGuid))
                return "startMsgGuid: string expected";
        if (message.endMsgGuid != null && message.hasOwnProperty("endMsgGuid"))
            if (!$util.isString(message.endMsgGuid))
                return "endMsgGuid: string expected";
        return null;
    };

    /**
     * Creates a MsgReadStatusMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MsgReadStatusMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MsgReadStatusMsg} MsgReadStatusMsg
     */
    MsgReadStatusMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.MsgReadStatusMsg)
            return object;
        var message = new $root.MsgReadStatusMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        if (object.targetGuid != null)
            message.targetGuid = String(object.targetGuid);
        if (object.msgGuid) {
            if (!Array.isArray(object.msgGuid))
                throw TypeError(".MsgReadStatusMsg.msgGuid: array expected");
            message.msgGuid = [];
            for (var i = 0; i < object.msgGuid.length; ++i)
                message.msgGuid[i] = String(object.msgGuid[i]);
        }
        if (object.startMsgGuid != null)
            message.startMsgGuid = String(object.startMsgGuid);
        if (object.endMsgGuid != null)
            message.endMsgGuid = String(object.endMsgGuid);
        return message;
    };

    /**
     * Creates a plain object from a MsgReadStatusMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MsgReadStatusMsg
     * @static
     * @param {MsgReadStatusMsg} message MsgReadStatusMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MsgReadStatusMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.msgGuid = [];
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.fromGuid = "";
            object.targetGuid = "";
            object.startMsgGuid = "";
            object.endMsgGuid = "";
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.targetGuid != null && message.hasOwnProperty("targetGuid"))
            object.targetGuid = message.targetGuid;
        if (message.msgGuid && message.msgGuid.length) {
            object.msgGuid = [];
            for (var j = 0; j < message.msgGuid.length; ++j)
                object.msgGuid[j] = message.msgGuid[j];
        }
        if (message.startMsgGuid != null && message.hasOwnProperty("startMsgGuid"))
            object.startMsgGuid = message.startMsgGuid;
        if (message.endMsgGuid != null && message.hasOwnProperty("endMsgGuid"))
            object.endMsgGuid = message.endMsgGuid;
        return object;
    };

    /**
     * Converts this MsgReadStatusMsg to JSON.
     * @function toJSON
     * @memberof MsgReadStatusMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MsgReadStatusMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MsgReadStatusMsg;
})();

module.exports = $root;
